module.exports = __webpack_public_path__ + "img/avito-logo.e332be84.svg";